// eslint-disable-next-line import/extensions,import/no-unresolved
import { showingPaywall, whenBecomesVisible } from '@/functions';

export default () => {
  // Event: click_suscription
  // No creamos listeners para elementos dentro del paywall
  const EVENT_NAME_CLICK_SUBSCRIPTION = 'click_suscription';
  document
    .querySelectorAll('a[href*=".infolibre.es/hazte_socio"], button[onclick*=".infolibre.es/hazte_socio"]')
    .forEach((item) => {
      if (item.closest('.paywall')) {
        return;
      }

      item.addEventListener('click', (event) => {
        const el = event.currentTarget;
        let eventData = {};
        if (el.dataset.dlSubscriptionParams !== undefined) {
          eventData = JSON.parse(el.dataset.dlSubscriptionParams);
        }
        window.dataLayer.push({ event: EVENT_NAME_CLICK_SUBSCRIPTION, eventData });
      });
    });

  // Eventos aumenta tu cuota en footer
  // https://mgr.bitban.com/issues/114379
  const EVENT_NAME_CLICK_INCREASE_QUOTA = 'increase_quota';
  const $partnerFooterInfo = document.querySelector('.partner .footer-info');
  if ($partnerFooterInfo) {
    $partnerFooterInfo.querySelector('.footer-btn').addEventListener('click', (event) => {
      const el = event.currentTarget;
      let eventData = {};
      if (el.dataset.dlSubscriptionParams !== undefined) {
        eventData = JSON.parse(el.dataset.dlSubscriptionParams);
      }
      window.dataLayer.push({ event: EVENT_NAME_CLICK_INCREASE_QUOTA, eventData });
    });
  }

  // Event: select_content
  // Event: click_rrss
  // Event: click_notification_alert
  document
    .querySelectorAll('a[data-dl-event], button[data-dl-event], span[data-dl-event]')
    .forEach((item) => {
      item.addEventListener('click', () => {
        let eventData = {};
        if (item.dataset.dlParams !== undefined) {
          eventData = JSON.parse(item.dataset.dlParams);
        }
        window.dataLayer.push({ event: item.dataset.dlEvent, eventData });
      });
    });

  // Event: click_podcast
  const EVENT_NAME_CLICK_CLICK_PODCAST = 'click_podcast';
  const PODCAST_DOMAIN_SPOTIFY = 'open.spotify.com';
  const PODCAST_DOMAIN_IVOOX = 'ivoox.com';
  const PODCAST_DOMAIN_GOOGLE = 'podcasts.google.com';
  document
    .querySelectorAll(
      '.article-text a[href^="https://open.spotify.com/"],'
      + '.article-text a[href^="https://go.ivoox.com/"],'
      + '.article-text a[href^="https://www.ivoox.com/"],'
      + '.article-text a[href^="https://podcasts.google.com/"]',
    )
    .forEach((item) => {
      const href = item.getAttribute('href');
      let platform;
      if (href.includes(PODCAST_DOMAIN_SPOTIFY)) {
        platform = 'Spotify';
      } else if (href.includes(PODCAST_DOMAIN_IVOOX)) {
        platform = 'iVoox';
      } else if (href.includes(PODCAST_DOMAIN_GOOGLE)) {
        platform = 'Google';
      }

      item.addEventListener('click', () => {
        window.dataLayer.push({
          event: EVENT_NAME_CLICK_CLICK_PODCAST,
          eventData: {
            method: platform,
            content_id: window.appInfo?.contentId ?? undefined,
          },
        });
      });
    });

  // Event: podcast_interaction
  const EVENT_NAME_PODCAST_INTERACTION = 'podcast_interaction';
  document
    .querySelectorAll('audio')
    .forEach((item) => {
      item.addEventListener('play', () => {
        window.dataLayer.push({
          event: EVENT_NAME_PODCAST_INTERACTION,
          eventData: {
            im_action: 'start',
            content_id: window.appInfo?.contentId ?? undefined,
          },
        });
      });

      item.addEventListener('pause', (e) => {
        window.dataLayer.push({
          event: EVENT_NAME_PODCAST_INTERACTION,
          eventData: {
            /* eslint no-mixed-operators: "error" */
            im_action: `pause_${Math.round(e.target.currentTime * 100 / item.duration * 100) / 100}`,
            content_id: window.appInfo?.contentId ?? undefined,
          },
        });
      });

      item.addEventListener('ended', () => {
        window.dataLayer.push({
          event: EVENT_NAME_PODCAST_INTERACTION,
          eventData: {
            im_action: 'complete',
            content_id: window.appInfo?.contentId ?? undefined,
          },
        });
      });
    });

  if (showingPaywall) {
    const EVENT_NAME_SHOW_PAYWALL = 'show_paywall';
    const EVENT_NAME_CLICK_SUBSCRIPTION_PAYWALL = 'add_to_cart';
    const EVENT_NAME_CLICK_SIGNIN = 'click_registro';
    const EVENT_NAME_VIEW_PAYWALL = 'view_paywall';

    window.stackDataLayerEvents = window.stackDataLayerEvents || [];
    window.stackDataLayerEvents.push({
      priority: 0,
      data: { event: EVENT_NAME_SHOW_PAYWALL },
    });

    Array
      .from(document.getElementsByClassName('offer__suscription'))
      .forEach((item) => {
        item.addEventListener('click', () => {
          const ecommerceParams = JSON.parse(item.dataset.dlSubscriptionParams);
          window.dataLayer.push({
            event: EVENT_NAME_CLICK_SUBSCRIPTION_PAYWALL,
            ecommerce: {
              ...ecommerceParams,
            },
          });
        });
      });

    const signinLink = document.getElementById('paywall-signin');
    if (signinLink) {
      signinLink.addEventListener('click', () => {
        if (signinLink.dataset.dlSigninParams === undefined) {
          window.dataLayer.push({ event: EVENT_NAME_CLICK_SIGNIN });
          return;
        }

        const signinParams = JSON.parse(signinLink.dataset.dlSigninParams);
        window.dataLayer.push({
          event: EVENT_NAME_CLICK_SIGNIN,
          eventData: {
            ...signinParams,
          },
        });
      });
    }

    const paywallWrapper = document.querySelector('.paywall__wrapper');
    if (paywallWrapper) {
      whenBecomesVisible(paywallWrapper, () => {
        window.dataLayer.push({ event: EVENT_NAME_VIEW_PAYWALL });
      });
    }
  }

  // Event: click_login
  const EVENT_NAME_CLICK_LOGIN = 'click_login';
  document
    .querySelectorAll('a[href*=".infolibre.es/iniciar-sesion"]')
    .forEach((item) => {
      item.addEventListener('click', () => {
        // Especificación cuando el click se hace en la capa de paywall
        if (showingPaywall) {
          if (item.dataset.dlLoginParams === undefined) {
            window.dataLayer.push({ event: EVENT_NAME_CLICK_LOGIN });
            return;
          }

          const loginParams = JSON.parse(item.dataset.dlLoginParams);
          window.dataLayer.push({
            event: EVENT_NAME_CLICK_LOGIN,
            eventData: {
              ...loginParams,
            },
          });
          return;
        }
        const imLocation = item.closest('.cmp-main-menu-tablet') ? 'burger_menu' : 'other';
        window.dataLayer.push({
          event: EVENT_NAME_CLICK_LOGIN,
          eventData: {
            im_location: imLocation,
          },
        });
      });
    });

  // Definición: https://mgr.bitban.com/issues/74198

  // // Cuando está visible el módulo de captación
  // const $recruitModule = document.querySelector('.news-partners-recruitment');
  // if ($recruitModule) {
  //   let recruitNotified = false;
  //   whenBecomesVisible($recruitModule, () => {
  //     if (!recruitNotified){
  //       recruitNotified = true;
  //       if ($recruitModule.className.match(/focus/)) {
  //         window.dataLayer.push({'event': 'foco_viewed'});
  //       } else {
  //         window.dataLayer.push({'event': 'promo_viewed'});
  //       }
  //     }
  //   });
  //
  //   let $button = $recruitModule.querySelector('.content-link');
  //   if ($button !== null) {
  //     if ($recruitModule.className.match(/focus/)) {
  //       $button.addEventListener("click", e => {
  //         window.dataLayer.push({'event': 'foco_click'});
  //       });
  //     } else {
  //       $button.addEventListener("click", e => {
  //         window.dataLayer.push({'event': 'promo_click'});
  //       });
  //     }
  //   }
  // }

  // // Cuando se ha visto la "noticia", lanzamos el evento
  // const contentBody = document.querySelector('.article-page__body-row');
  // const contentLastBodyItem = contentBody ? contentBody : null;

  // let $newsBody = document.querySelector('.article-page__body-row');
  // let $newsLastBodyItem = null;
  // if ($newsBody) {
  //   $newsLastBodyItem = $newsBody.lastElementChild;
  // }
  // let newsReadNotified = false;
  // if ($newsLastBodyItem) {
  //   // No se tiene que lanzar este evento si se muestra el paywall
  //   if (document.querySelector('.paywall.paywall--closed1') === null
  //     && document.querySelector('.paywall.paywall--closed2') === null) {
  //     whenBecomesVisible($newsLastBodyItem, () => {
  //       if (!newsReadNotified) {
  //         newsReadNotified = true;
  //         window.dataLayer.push({'event': 'final_noticia'});
  //       }
  //     });
  //   }
  // }

  // // Eventos de cabecera
  // // https://mgr.bitban.com/issues/74359
  // let $hottopics = document.querySelectorAll('.header-home .owl-item a');
  // if ($hottopics) {
  //   $hottopics.forEach($el => {
  //     $el.addEventListener("click", e => {
  //       window.dataLayer.push({'event': 'click_bar_item', 'event_action': e.currentTarget.text.trim() });
  //     });
  //   });
  // }

  // // Eventos activación menú
  // let $hamButton = document.querySelector('.hamburguer-icon');
  // if ($hamButton) {
  //   $hamButton.addEventListener("click", e => {
  //     if (e.currentTarget.classList.contains("open")) {
  //       window.dataLayer.push({'event': 'menu_on'});
  //     } else {
  //       window.dataLayer.push({'event': 'menu_off'});
  //     }
  //   });
  // }

  // // Eventos elementos dentro del menú hamburguesa
  // let $hamLinks = document.querySelectorAll('.menu-header a');
  // if ($hamLinks) {
  //   $hamLinks.forEach($el => {
  //     $el.addEventListener("click", e => {
  //       window.dataLayer.push({'event': 'click_menu_item', 'event_action': e.currentTarget.text.trim() });
  //     });
  //   });
  // }

  // Eventos del buscador de cabecera (ver searcher.js)

  // // Eventos de subsecciones/urgente
  // let $sectionheader = document.querySelectorAll('.sectionheader .owl-item a, .last-minute a');
  // if ($sectionheader) {
  //   $sectionheader.forEach($el => {
  //     $el.addEventListener("click", e => {
  //       window.dataLayer.push({'event': 'click_subsecciones', 'event_action': e.currentTarget.text.trim()});
  //     });
  //   });
  // }

  // // Evento de menú de usuario
  // let $userMenu = document.querySelector('.user-menu .fa-chevron-down');
  // if ($userMenu) {
  //   $userMenu.addEventListener("click", e => {
  //     if (e.currentTarget.classList.contains("active")) {
  //       window.dataLayer.push({'event': 'menu_perfil_off'});
  //     } else {
  //       window.dataLayer.push({'event': 'menu_perfil_on'});
  //     }
  //     document.querySelectorAll(".user-menu .cont-options a").forEach($el => {
  //       $el.addEventListener("click", e => {
  //         window.dataLayer.push({'event': 'click_menu_item', 'event_action': e.currentTarget.text.trim() });
  //       });
  //     });
  //   });
  // }

  // Eventos paywall
  // Paywall Adelanto:
  const $paywallAdvance = document.querySelector('.paywall.paywall--advance');
  if ($paywallAdvance) {
    window.dataLayer.push({ event: 'adelanto_show' });
  }

  // Paywall closed 1:
  const $paywallClosed = document.querySelector('.paywall.paywall--closed1');
  if ($paywallClosed) {
    document.querySelectorAll('.paywall.paywall--closed1 a.exit-btn').forEach(($el) => {
      $el.addEventListener('click', () => {
        window.dataLayer.push({ event: 'paywall_hazte_socio_bonificado_test_A' });
      });
    });

    // Evento paywall seguir navegando en cabcera
    const $haderSmallLogoLink = document.querySelectorAll('.header-small .hlogo a');
    if ($haderSmallLogoLink) {
      $haderSmallLogoLink.forEach(($el) => {
        $el.addEventListener('click', () => {
          window.dataLayer.push({ event: 'paywall_seguir_navegando_test_A' });
        });
      });
    }

    // Evento hazte socio de la cabecera
    const $haderBecomePartnerLnk = document.querySelectorAll('.header-small .user-header .become-partner a');
    if ($haderBecomePartnerLnk) {
      $haderBecomePartnerLnk.forEach(($el) => {
        $el.addEventListener('click', () => {
          window.dataLayer.push({ event: 'Hazte_socio_arriba' });
        });
      });
    }
  }

  // Paywall closed 2
  const $paywallClosedB = document.querySelector('.paywall.paywall--closed2');
  if ($paywallClosedB) {
    document.querySelectorAll('.paywall.paywall--closed2 a.exit-btn').forEach(($el) => {
      $el.addEventListener('click', () => {
        window.dataLayer.push({ event: 'paywall_hazte_socio_bonificado_test_B' });
      });
    });

    // Evento paywall seguir navegando en cabcera
    const $haderSmallLogoLink = document.querySelectorAll('.header-small .hlogo a');
    if ($haderSmallLogoLink) {
      $haderSmallLogoLink.forEach(($el) => {
        $el.addEventListener('click', () => {
          window.dataLayer.push({ event: 'paywall_seguir_navegando_test_B' });
        });
      });
    }

    // Evento hazte socio de la cabecera
    const $haderBecomePartnerLnk = document.querySelectorAll('.header-small .user-header .become-partner a');
    if ($haderBecomePartnerLnk) {
      $haderBecomePartnerLnk.forEach(($el) => {
        $el.addEventListener('click', () => {
          window.dataLayer.push({ event: 'Hazte_socio_arriba' });
        });
      });
    }
  }
};
